// const addDecor = function () {
//   document.querySelectorAll('.art__num').forEach((el) => {
//     const decor = '<div class="num__decor"></div>';
//     el.insertAdjacentHTML('beforeend', decor);
//   });
// };
//
// window.addEventListener('DOMContentLoaded', () => {
//   addDecor();
// });

// window.addEventListener('load', () => {
//
// });
//
// window.addEventListener('resize', (event) => {
//
// });
